import { render, staticRenderFns } from "./NewEdit.vue?vue&type=template&id=22cb51ea&"
import script from "../../models/login-members/new-edit.ts?vue&type=script&lang=ts&"
export * from "../../models/login-members/new-edit.ts?vue&type=script&lang=ts&"
import style0 from "./NewEdit.vue?vue&type=style&index=0&id=22cb51ea&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports